import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Color palette */
    --primary-green: #2E8B57;
    --primary-green-dark: #1f5f3f;
    --primary-green-light: #90EE90;
    --secondary-blue: #4682B4;
    --accent-orange: #FF6B35;
    --neutral-white: #ffffff;
    --neutral-gray-50: #fafafa;
    --neutral-gray-100: #f5f5f5;
    --neutral-gray-200: #e5e5e5;
    --neutral-gray-300: #d4d4d4;
    --neutral-gray-400: #a3a3a3;
    --neutral-gray-500: #737373;
    --neutral-gray-600: #525252;
    --neutral-gray-700: #404040;
    --neutral-gray-800: #262626;
    --neutral-gray-900: #171717;
    
    /* Spacing */
    --space-xs: 0.25rem;
    --space-sm: 0.5rem;
    --space-md: 1rem;
    --space-lg: 1.5rem;
    --space-xl: 2rem;
    --space-2xl: 3rem;
    --space-3xl: 4rem;
    
    /* Typography */
    --font-family-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    --font-family-display: 'Playfair Display', serif;
    
    /* Shadows */
    --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    
    /* Border radius */
    --radius-sm: 0.25rem;
    --radius-md: 0.5rem;
    --radius-lg: 0.75rem;
    --radius-xl: 1rem;
    --radius-2xl: 1.5rem;
    
    /* Transitions */
    --transition-fast: 0.15s ease;
    --transition-base: 0.3s ease;
    --transition-slow: 0.5s ease;
    
    /* Z-index scale */
    --z-dropdown: 1000;
    --z-sticky: 1020;
    --z-fixed: 1030;
    --z-modal-backdrop: 1040;
    --z-modal: 1050;
    --z-popover: 1060;
    --z-tooltip: 1070;
    --z-toast: 1080;
  }

  /* Custom scrollbar for webkit browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--neutral-gray-100);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--neutral-gray-300);
    border-radius: var(--radius-md);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--neutral-gray-400);
  }

  /* Focus styles for accessibility */
  *:focus-visible {
    outline: 2px solid var(--primary-green);
    outline-offset: 2px;
  }

  /* Remove default focus styles */
  *:focus {
    outline: none;
  }

  /* Selection styles */
  ::selection {
    background-color: var(--primary-green-light);
    color: var(--neutral-gray-900);
  }

  /* Print styles */
  @media print {
    * {
      color: black !important;
      background: white !important;
    }
  }
`;

export default GlobalStyles;
